"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrentStructureWithHtgHx = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.symbol.description.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
var _Types = require("../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const getCurrentStructureWithHtgHx = _ref => {
  var _ref2, _totalHtgHxById$activ;
  let {
    structure,
    activeHtgHx
  } = _ref;
  const totalHtgHxById = structure.active.HtgHx;
  const totalHtgPipeById = structure.active.HtgPipe;
  const activeHtgHxGroupId = (_ref2 = activeHtgHx !== null && activeHtgHx !== void 0 ? activeHtgHx : Object.keys(totalHtgHxById)[0]) !== null && _ref2 !== void 0 ? _ref2 : null;
  if (!activeHtgHxGroupId) {
    return {
      active: structure.active,
      byHtgSys: _objectSpread(_objectSpread({}, structure.byHtgSys), {}, {
        htgHx: totalHtgHxById
      })
    };
  }
  /** get htgHx that is connected to the active htgHx */
  const htgHxConnectedToActiveHx = activeHtgHxGroupId ? Object.values(totalHtgHxById).find(hx => {
    var _hx$LinkTo$HtgHx;
    return (_hx$LinkTo$HtgHx = hx[_constants.LinkTo.HtgHx]) === null || _hx$LinkTo$HtgHx === void 0 ? void 0 : _hx$LinkTo$HtgHx.includes(activeHtgHxGroupId);
  }) : null;
  /** make list of active HtgHx */
  const htgHxList = _objectSpread({
    [activeHtgHxGroupId]: totalHtgHxById[activeHtgHxGroupId]
  }, htgHxConnectedToActiveHx && {
    [htgHxConnectedToActiveHx.id]: htgHxConnectedToActiveHx
  });
  /** make list of active HtgPipe */
  const htgPipeList = ((_totalHtgHxById$activ = totalHtgHxById[activeHtgHxGroupId]) === null || _totalHtgHxById$activ === void 0 || (_totalHtgHxById$activ = _totalHtgHxById$activ[_constants.LinkTo.HtgPipe]) === null || _totalHtgHxById$activ === void 0 ? void 0 : _totalHtgHxById$activ.reduce((acc, pipeId) => _objectSpread(_objectSpread({}, acc), {}, {
    [pipeId]: totalHtgPipeById[pipeId]
  }), {})) || {};
  return {
    active: _objectSpread(_objectSpread({}, structure.active), {}, {
      [_constants.ComponentTypes.HtgHx]: htgHxList,
      [_constants.ComponentTypes.HtgPipe]: htgPipeList
    }),
    byHtgSys: _objectSpread(_objectSpread({}, structure.byHtgSys), {}, {
      [_constants.ComponentTypes.HtgHx]: totalHtgHxById
    })
  };
};
exports.getCurrentStructureWithHtgHx = getCurrentStructureWithHtgHx;
getCurrentStructureWithHtgHx.propTypes = {
  structure: _Types.structureType,
  activeHtgHx: _propTypes.default.string
};